import React, { Fragment, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate, useSearchParams } from 'react-router-dom';
import { LayoutBar } from '../components/Layout';
import { useRoutePermission } from '../hooks';
import { useAppSelector } from '../reducer/hooks';
import { selectProfile } from '../reducer/profileSlice';
import { ROUTE_INFOS, RouteInfo } from '../routes';

interface IProps {}

const AuthenticatedRoutes = (props: IProps) => {
  const { hasRoutePermission } = useRoutePermission();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const acceptLevelParam = searchParams.get('acceptLevel');
  const acceptLevel = acceptLevelParam ?? '1';
  const profile = useAppSelector(selectProfile);

  const withPermission = (routeInfos: RouteInfo[]) =>
    routeInfos.filter(({ key }) => hasRoutePermission(key));

  const createRoutes = (routeInfos: RouteInfo[]): React.ReactElement => {
    return (
      <>
        {routeInfos.map((routeInfo: RouteInfo) => {
          const { key, route, element, children } = routeInfo;

          if (children && children.length > 0) {
            return createRoutes(withPermission(children));
          }

          return <Route key={key} path={route} element={element} />;
        })}
      </>
    );
  };

  const authorizedRoutes = createRoutes(withPermission(ROUTE_INFOS));

  // Auto Navigate to /transactionRequest
  useEffect(() => {
    const hasLevelPermission = profile.featureList.some(
      (featureCode) => featureCode === `transaction_request/view/level_${acceptLevel}`
    );
    if (!hasLevelPermission) {
      navigate(`/transactionRequest?acceptLevel=${1}`);
    } else {
      navigate(`/transactionRequest?acceptLevel=${acceptLevel}`);
    }
  }, []);

  return (
    <Routes>
      <Route path="/" element={<LayoutBar />}>
        {authorizedRoutes}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Route>
    </Routes>
  );
};

export default AuthenticatedRoutes;
